let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iwHwB")).then(() => parcelRequire('1fv9y'));